import FAQModal from './FAQModal';

export default FAQModal;
